import lazyLoad from "@loadable/component";
import createPlugin from "./createPlugin";
import ProductSliderRenderer from "./Renderer/ProductSliderRenderer";

const ProductSliderForm = lazyLoad(() => import("./Form/ProductSlider-Form"));

const ProductSliderPlugin = (settings) =>
  createPlugin({
    Renderer: ProductSliderRenderer,
    Controls: ProductSliderForm,
    ...settings,
  });

const ProductSlider = ProductSliderPlugin();
export default ProductSlider;

export { ProductSliderPlugin, ProductSliderRenderer };
